(function() {

  var SCROLL_THRESOLDS = [10,25,50,75,90,100];
  var triggeredThresholds = {};
  var ticking = false;

  // ===== CLICK TRACKING =====
  function getLinkElement(node) {
    while (node && node !== document) {
      if (node.tagName === "A") return node;
      node = node.parentNode;
    }
    return null;
  }

  function handleClick(e) {

    var link = getLinkElement(e.target);
    var isLink = link && link.tagName === "A";

    var href = isLink && link.href ? link.href : "";
    var target = isLink && link.target ? link.target : "";

    // Detect outbound
    var isOutbound = false;
    if (href) {
      var a = document.createElement("a");
      a.href = href;
      if (a.hostname && a.hostname !== location.hostname) {
        isOutbound = true;
      }
    }

    if (typeof Shopify !== "undefined" && Shopify.analytics && Shopify.analytics.publish) {
      Shopify.analytics.publish("click", {
        event: "custom_click",
        event_source: "custom_pixel",
        elementClasses: e.target.className || "",
        elementId: e.target.id || "",
        elementText: e.target.innerText ? e.target.innerText.replace(/\n/g,"") : "",
        elementTarget: target,
        elementUrl: href,
        linkType: isLink ? (isOutbound ? "outbound" : "inbound") : "not_link"
      });
    }
  }

  // ===== SCROLL TRACKING =====
  function getScrollPercent() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;

    if (docHeight <= 0) return 0;

    return Math.round((scrollTop / docHeight) * 100);
  }

  function handleScroll() {
    var percent = getScrollPercent();

    for (var i = 0; i < SCROLL_THRESOLDS.length; i++) {
      var th = SCROLL_THRESOLDS[i];

      if (percent >= th && !triggeredThresholds[th]) {

        if (typeof Shopify !== "undefined" && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish("scroll_depth", {
            event: "custom_scroll",
            event_source: "custom_pixel",
            scrollThreshold: th,
            scrollUnits: "percent",
            scrollDirection: "vertical"
          });
        }

        triggeredThresholds[th] = true;
      }
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(handleScroll);
      ticking = true;
    }
  }

  // ===== INIT =====
  function init() {
    document.addEventListener("click", handleClick, true); // capture phase
    window.addEventListener("scroll", onScroll);

    // trigger once
    handleScroll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();